<div
  *ngIf="
    (skillGroups?.length ?? 0) > 0 ||
      (uncategorizedSkillGroups?.length ?? 0) > 0;
    else emptyState
  "
>
  <!-- Categorized -->
  <mat-expansion-panel *ngIf="(skillGroups?.length ?? 0) > 0" [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>Skill Groups with Capabilities</mat-panel-title>
    </mat-expansion-panel-header>

    <mat-chip-set>
      <mat-chip
        *ngFor="let skillGroup of skillGroups"
        [color]="
          selectedSkillGroup?.Id === skillGroup.Id ? 'primary' : undefined
        "
        (click)="selectSkillGroup(skillGroup)"
      >
        {{ skillGroup.Name }}
      </mat-chip>
    </mat-chip-set>
  </mat-expansion-panel>

  <!-- Uncategorized -->
  <mat-expansion-panel
    *ngIf="(uncategorizedSkillGroups?.length ?? 0) > 0"
    [expanded]="true"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>Uncategorized Skill Groups</mat-panel-title>
    </mat-expansion-panel-header>

    <mat-chip-set>
      <mat-chip
        *ngFor="let skillGroup of uncategorizedSkillGroups"
        [color]="
          selectedSkillGroup?.Id === skillGroup.Id ? 'primary' : undefined
        "
        (click)="selectSkillGroup(skillGroup)"
      >
        {{ skillGroup.Name }}
      </mat-chip>
    </mat-chip-set>
  </mat-expansion-panel>
</div>

<ng-template #emptyState>
  <div class="skill-groups-empty">No skill groups found.</div>
</ng-template>
